import { render, staticRenderFns } from "./UserAccessFeaturesSelector.vue?vue&type=template&id=46d0b052"
import script from "./UserAccessFeaturesSelector.vue?vue&type=script&lang=js"
export * from "./UserAccessFeaturesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports